import type { ValidatedOAuthContext } from '../types';

/**
 * Posts a message to the window opener or parent.
 * Callback SPA may run in a popup (window.opener) or within an iframe (window.parent).
 */
export function postToOpener(payload: any) {
  const target: any = window.opener || window.parent;
  if (!target || target === window) return;
  target.postMessage(payload, '*'); // receiver validates origin + state
}

/**
 * Formats debug information for display in the UI.
 */
export function formatDebug(ctx: ValidatedOAuthContext): string {
  const safe = (v: any) => (v == null ? '' : String(v));
  return [`sessionId: ${safe(ctx.sessionId)}`, `clientId: ${safe(ctx.clientInfo?.client_id)}`, `organizations: ${ctx.organizations.length}`, `roleId: ${safe(ctx.role_id)}`].join(
    '\n',
  );
}
